<template>
  <el-dialog
    title="选择金币账户"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <div class="filter-container">
      <el-input
        v-model="queryParams.communityName"
        placeholder="输入小区名称"
        style="width: 300px; margin-right: 10px;"
        clearable
      />
      <el-button type="primary" @click="handleQuery">查询</el-button>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px;"
    >
      <el-table-column prop="communityName" label="小区名称" align="center" />
      <el-table-column prop="goldName" label="账户名称" align="center" />
      <el-table-column prop="amount" label="账户余额" align="center" />
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="{row}">
          <el-button type="primary" size="mini" @click="handleChoose(row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :page-size="queryParams.row"
        :current-page="queryParams.page"
        @current-change="handlePageChange"
      />
    </div>
  </el-dialog>
</template>

<script>
import { listGold } from '@/api/admin/goldApi'

export default {
  name: 'ChooseGold',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
      queryParams: {
        page: 1,
        row: 10,
        communityName: ''
      },
      currentGold: null
    }
  },
  methods: {
    open(goldInfo) {
      this.currentGold = goldInfo
      this.dialogVisible = true
      this.getList()
    },
    handleClose() {
      this.queryParams.communityName = ''
      this.queryParams.page = 1
    },
    handleQuery() {
      this.queryParams.page = 1
      this.getList()
    },
    handlePageChange(val) {
      this.queryParams.page = val
      this.getList()
    },
    async getList() {
      this.loading = true
      try {
        const res = await listGold(this.queryParams)
        this.tableData = res.data
        this.total = res.total || 0
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleChoose(row) {
      Object.assign(this.currentGold, {
        goldId: row.goldId,
        goldName: row.goldName,
        communityName: row.communityName,
        amount: row.amount
      })
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>